import Breadcrumbs from './common/Breadcrumbs/Breadcrumbs';

interface ILayoutProps {
  children: any;
}

export default function Layout({ children }: ILayoutProps) {
  return (
    <>
      <Breadcrumbs title="Contracts&Billing" />
      {children}
    </>
  );
}
